import { Card, CardContent, Typography, Grid, Divider, Box, Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow, Paper, } from "@mui/material";
import { useMechanicsConfiguration } from "../../context/MechanicsConfigurationContext.tsx";
import { getHousingInfo } from "../../utils/housingDetails.ts";

const MechanicsSummary = () => {
  const { config: mechanicsConfig } = useMechanicsConfiguration();

  const arrangementTableRows = [
    { label: "Breite", value: `${mechanicsConfig.mechanics.dut_width} mm` },
    { label: "Höhe", value: `${mechanicsConfig.mechanics.dut_height} mm` },
    {
      label: "X-Achse",
      value: `Anzahl: ${mechanicsConfig.arrangement.x.count}, Offset: ${mechanicsConfig.arrangement.x.offset} mm, Abstand: ${mechanicsConfig.arrangement.x.distance} mm`
    },
    {
      label: "Y-Achse",
      value: `Anzahl: ${mechanicsConfig.arrangement.y.count}, Offset: ${mechanicsConfig.arrangement.y.offset} mm, Abstand: ${mechanicsConfig.arrangement.y.distance} mm`
    }
  ];

  const testpointTableRows = [
    { label: "Anzahl", value: `${mechanicsConfig.testpoints.length}` },
    {
      label: "Seite",
      value:
        mechanicsConfig.testpoints.length > 0
          ? mechanicsConfig.testpoints[0].side
          : "noch kein Testpunkt vorhanden"
    }
  ];

  const housingTableRows = [
    {
      label: "Gehäuse Typ",
      value: mechanicsConfig.mechanics.housing.toUpperCase()
    },
    {
      label: "Mit Bedienelement",
      value: mechanicsConfig.mechanics.user_interface ? "Ja" : "Nein"
    },
    {
      label: "Mit automatischer Schließerkennung",
      value: mechanicsConfig.mechanics.switch ? "Ja" : "Nein"
    },
    {
      label: "Größe Gerät",
      value: getHousingInfo(mechanicsConfig.mechanics)?.deviceSize
    },
    {
      label: "Max. Größe DUT",
      value: `${getHousingInfo(mechanicsConfig.mechanics)?.dutX} x ${getHousingInfo(mechanicsConfig.mechanics)?.dutY} mm`
    },
    {
      label: "Anzahl Modulslots",
      value: getHousingInfo(mechanicsConfig.mechanics)?.maxModules
    },
  ];

  return (
    <>
      <Typography variant="h6">Mechanik</Typography>
      <Box mt={2} />
      <Grid container spacing={2}>
        <Grid size={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Gehäuse</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {housingTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Typography variant="h6">DUT & Anordnung</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {arrangementTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Grid>
        <Grid size={6}>
          <Card>
            <CardContent>
              <Typography variant="h6">Testpunkte</Typography>
              <Divider sx={{ my: 1 }} />
              <TableContainer component={Paper} elevation={1}>
                <Table size="small" aria-label="DUT-Anordnung">
                  <TableBody>
                    {testpointTableRows.map((row, i) => (
                      <TableRow key={i}>
                        <TableCell sx={{ width: '50%' }}>{row.label}</TableCell>
                        <TableCell sx={{ width: '50%' }}>{row.value}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
          <Card>
            <CardContent>
              <Box mt={6} />
              <Box
                sx={{
                  backgroundColor: "#aaaaaa",
                  padding: 0,
                  borderRadius: 1,
                  display: "flex",
                }}
              >
                <img
                  src={getHousingInfo(mechanicsConfig.mechanics)?.image}
                  alt="Gehäuseabbildung"
                  style={{ width: "100%", maxHeight: 300, objectFit: "contain" }}
                />
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </>
  )
};

export default MechanicsSummary;